import Vue from 'vue'
import ElementUI from 'element-ui'
import App from './App.vue'
import router from './router'
import store from './store'
import request from './utils/request'
import tools from './utils/tools'

import './assets/styles/froala_style.min.css'
import 'element-ui/lib/theme-chalk/index.css'

Vue.prototype.$http = request
Vue.prototype.$tools = tools

Vue.config.productionTip = false

Vue.prototype.$changeTitle = function(title) {
  // 修改网页标题
  document.title = title
}

// 修改网页图标
let favicon = document.querySelector('link[rel="shortcut icon"]')
favicon.href = require('./assets/images/icon.png')

Vue.use(ElementUI)

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js